import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

// Admin nav entry with a red badge showing how many items still need review
// (open flags + open data alerts + unverified circuits). Clears only when the
// underlying item is resolved. Polls every 60s and on window focus.
export default function AdminNavLink() {
    const [count, setCount] = useState(0);

    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const { data } = await api.get("/admin/nav-counts");
                if (alive) setCount((data?.flags || 0) + (data?.alerts || 0) + (data?.circuits || 0));
            } catch {
                /* ignore transient errors */
            }
        };
        load();
        const id = setInterval(load, 60000);
        const onFocus = () => load();
        window.addEventListener("focus", onFocus);
        return () => { alive = false; clearInterval(id); window.removeEventListener("focus", onFocus); };
    }, []);

    return (
        <Link
            to="/admin"
            data-testid="nav-admin"
            title={count > 0 ? `${count} item${count === 1 ? "" : "s"} need review` : "Admin"}
            className="relative hidden md:inline-flex items-center gap-1.5 text-sm uppercase tracking-wider text-[#ff4500] hover:text-white transition-colors px-3 py-2 font-semibold"
        >
            Admin
            {count > 0 && (
                <span
                    data-testid="admin-flags-badge"
                    className="min-w-[18px] h-[18px] px-1 bg-[#ff4500] text-white text-[10px] font-bold rounded-full inline-flex items-center justify-center leading-none"
                >
                    {count > 9 ? "9+" : count}
                </span>
            )}
        </Link>
    );
}
